import { twMerge } from "tailwind-merge";

import { DeleteIcon } from "~/common/components/icons";
import { PencilIcon } from "~/common/components/icons/PencilIcon";
import { PharmacyBoxLayout } from "~/common/components/PharmacyBoxLayout";
import { Tag } from "~/common/components/Tag";
import { useSetDefaultPatientPharmacy } from "~/common/hooks/queries/pharmacy";
import { PharmacyQueryType } from "~/common/types/pharmacies";
import { formatPhoneNumber } from "~/common/utils/formatPhoneNumber";

interface PharmacyCardProps {
  patientPharmacy: PharmacyQueryType;
  patientId?: string;
  canEdit?: boolean;
  setPharmacyIdToDelete: (id: string) => void;
  setPharmacyForm: (pharmacy: PharmacyQueryType) => void;
}

export const PharmacyCard = ({
  patientPharmacy,
  patientId,
  canEdit = true,
  setPharmacyIdToDelete,
  setPharmacyForm,
}: PharmacyCardProps) => {
  const { pharmacy } = patientPharmacy;
  const { address } = pharmacy;

  const { setDefaultPharmacyMutation, isPending } =
    useSetDefaultPatientPharmacy(patientId);

  return (
    <PharmacyBoxLayout>
      <div className="truncate">
        <h4 className="font-semibold">{pharmacy.name}</h4>
        <p>{address.street}</p>
        <p>
          {address.city}, {address.state}
        </p>
        <p>{formatPhoneNumber(pharmacy.phone_number)}</p>
      </div>

      <div className="flex items-center justify-between">
        {patientPharmacy.is_default ? (
          <Tag className="bg-primary-100 text-primary-600">Default</Tag>
        ) : canEdit ? (
          <button
            type="button"
            className={twMerge(
              "font-medium text-primary-600",
              isPending && "text-gray-70",
            )}
            disabled={isPending}
            onClick={() => setDefaultPharmacyMutation(patientPharmacy.id)}
          >
            Set as default
          </button>
        ) : null}
        {canEdit && (
          <div className="flex items-center justify-between gap-3">
            <button
              type="button"
              onClick={() => setPharmacyForm(patientPharmacy)}
            >
              <PencilIcon className="size-5 text-gray-20 hover:text-blue-600" />
            </button>

            <button
              type="button"
              onClick={() => setPharmacyIdToDelete(patientPharmacy.id)}
            >
              <DeleteIcon className="size-5 text-gray-20 hover:text-blue-600" />
            </button>
          </div>
        )}
      </div>
    </PharmacyBoxLayout>
  );
};
